import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExtensionOnboardingPage = loadAsyncComponent(() => import('./Container'), 'page');
